'use client'

import styled from '@emotion/styled'
import MenuIcon from '@mui/icons-material/Menu'
import Box from '@mui/material/Box'
import MuiButton from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import { useState } from 'react'
import StoreBadges from '~/app/_components/badges'
import Logo from '~/app/_components/brand/logo'

const StyledDrawer = styled(Drawer)`
  .MuiDrawer-paper {
    background: rgba(10, 25, 41, 0.95);
    backdrop-filter: blur(40px);
    width: 280px;
    padding: 24px;
    height: 100%;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
  }

  .logo {
    width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 24px;

    svg {
      width: 100%;
    }
  }

  .link {
    font-weight: 500;
    text-decoration: none;
    padding: 6px 0;
    color: rgba(255, 255, 255, 0.8);
    font-size: 1rem;
    text-align: center;

    transition: all 300ms;

    &:hover {
      color: #ffffff;
    }
  }
`

export default function DrawerMenu({ isScrolled }: { isScrolled: boolean }) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Box onClick={() => setOpen(!open)}>
        <MenuIcon sx={{ color: '#f0f0f1', cursor: 'pointer' }} />
      </Box>

      <StyledDrawer anchor='right' open={open} onClose={() => setOpen(false)}>
        <Stack sx={{ height: '100%', pt: 4 }} alignItems='center'>
          <Link href='/' className='logo' onClick={() => setOpen(false)}>
            <Logo id='drawer-logo' gradient={true} />
          </Link>

          <Stack spacing={1.5} alignItems='center' sx={{ mt: 4 }}>
            <Link className='link' href='/about-us' onClick={() => setOpen(false)}>
              About Us
            </Link>
            <Link className='link' href='/technology' onClick={() => setOpen(false)}>
              Technology
            </Link>
            <Link
              className='link'
              href='/consultation'
              onClick={() => setOpen(false)}
            >
              Consultation
            </Link>
          </Stack>

          <Divider
            sx={{
              borderColor: 'rgba(255, 255, 255, 0.1)',
              width: '100%',
              mt: 4,
              mb: 3,
            }}
          />

          <Stack spacing={1.5} sx={{ width: '100%' }}>
            <MuiButton
              href='/sign/in'
              variant='text'
              fullWidth
              sx={{
                color: 'white',
                textTransform: 'none',
                fontWeight: 500,
                justifyContent: 'flex-start',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' },
              }}
              onClick={() => setOpen(false)}
            >
              Login
            </MuiButton>
            <MuiButton
              href='/sign/up'
              variant='contained'
              fullWidth
              sx={{
                backgroundColor: '#06b6d4',
                textTransform: 'none',
                fontWeight: 500,
                '&:hover': { backgroundColor: '#0891b2' },
              }}
              onClick={() => setOpen(false)}
            >
              Sign up
            </MuiButton>
          </Stack>

          <Box sx={{ mt: 'auto', pb: 2 }}>
            <StoreBadges variant='dark' direction='column' />
          </Box>
        </Stack>
      </StyledDrawer>
    </>
  )
}
